module.exports = __webpack_public_path__ + "img/box7-img-1.25ea0edf.png";